var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29015",
    "data-name": "Group 29015",
    transform: "translate(-1049 -5567)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29014",
    "data-name": "Group 29014",
    transform: "translate(749 4975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28298",
    "data-name": "Group 28298",
    transform: "translate(-9 6)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1534",
    "data-name": "Ellipse 1534",
    cx: 27,
    cy: 27,
    r: 27,
    transform: "translate(309 586)",
    fill: "#0180e5"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_36330",
    "data-name": "Path 36330",
    d: "M12.313,26.125V15.313H1.5a1.5,1.5,0,1,1,0-3H12.313V1.5a1.5,1.5,0,1,1,3,0V12.313H26.125a1.5,1.5,0,0,1,0,3H15.313V26.125a1.5,1.5,0,0,1-3,0Z",
    transform: "translate(1062 5580)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.c5e9ba2235ac2dbb4b55fd18b1fbade9.svg";
export { ForwardRef as ReactComponent };